<script lang="ts" module>
  import CtaButton from '@/ui/elements/buttons/CTAButton.svelte';
  import DropDown, { type DropDownProps } from '@/ui/elements/dropdown/DropDown.svelte';

  export interface AIStyleProps {
    aiStyleItems?: DropDownProps['items'];
    onAIStyleClick?: (promtModifier: string) => void;
    aiStyleLabel?: string;
    aiStyleTooltip?: string;
    aiStyleLoading?: boolean;
    aiStyleDisabled?: boolean;
  }

  //export type AIPromProps = AdditionalProps & Pick<DropDownProps, 'items' | 'disabled'>;
</script>

<script lang="ts">
  let {
    aiStyleTooltip: toolTipProp = 'Reload AI',
    aiStyleLabel: labelProp = 'AI style',
    ...props
  }: AIStyleProps = $props();

  // By default, select first element
  let selected: string = $state('');

  $effect(() => {
    selected = props.aiStyleItems?.[0]?.value ?? '';
  });
</script>

<div class="flex items-center gap-3">
  {#if props.aiStyleItems && props.aiStyleItems?.length > 0}
    <p class="flex-1 font-sans text-sm font-normal text-c-base">{labelProp}:</p>
    <DropDown items={props.aiStyleItems ?? []} disabled={props.aiStyleDisabled} bind:selected
    ></DropDown>
    <CtaButton
      disabled={props.aiStyleDisabled}
      icon="MagicExchange"
      onclick={() => {
        props.onAIStyleClick?.(selected);
      }}
      variant="primary"
      tooltip={toolTipProp}
      loading={props.aiStyleLoading}
    ></CtaButton>
  {:else}
    <div class="flex-1"></div>
    <CtaButton
      disabled={props.aiStyleDisabled}
      onclick={() => {
        props.onAIStyleClick?.(selected);
      }}
      variant="primary"
      tooltip={toolTipProp}
      loading={props.aiStyleLoading}
    >
      {toolTipProp}
    </CtaButton>
  {/if}
</div>
